import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { MachineArt, inp, lab, greenBtn, DIALOG_FIT } from "@/components/laser/LaserParts";

export default function AddMachineDialog({ open, onOpenChange, catalog, onAdded }) {
  const [pick, setPick] = useState(null);
  const [nickname, setNickname] = useState("");
  const [serial, setSerial] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!pick) return toast.error("Tap the machine you own.");
    setBusy(true);
    try {
      await api("/laser/machines", { method: "POST", body: { catalog_id: pick, nickname: nickname || null, serial: serial || null } });
      toast.success("Machine added"); setPick(null); setNickname(""); setSerial(""); onOpenChange(false); onAdded();
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="z-[1001] overflow-y-auto border-[#333] bg-[#121212] text-white sm:max-w-2xl" style={DIALOG_FIT} data-testid="add-machine-dialog">
        <DialogHeader>
          <DialogTitle>Add your machine</DialogTitle>
          <DialogDescription className="text-neutral-400">Tap the ALR laser you own.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {catalog.map((c) => (
            <button key={c.id} onClick={() => setPick(c.id)} data-testid={`catalog-pick-${c.id}`} className="text-left transition-transform hover:-translate-y-0.5"
              style={{ padding: 10, borderRadius: 12, background: "#1A1A1A", border: `2px solid ${pick === c.id ? "#4CCC06" : "#333"}` }}>
              <MachineArt item={c} h={150} />
              <p className="mt-2 text-sm font-bold">{c.name}</p>
              <p className="text-[11px] text-neutral-400">{c.watts}W {c.laser_type}</p>
            </button>
          ))}
        </div>
        <div className="grid grid-cols-2 gap-3">
          <label><span style={lab}>NICKNAME (OPTIONAL)</span><input data-testid="machine-nickname" style={inp} value={nickname} onChange={(e) => setNickname(e.target.value)} placeholder="e.g. Truck 1" /></label>
          <label><span style={lab}>SERIAL # (OPTIONAL)</span><input data-testid="machine-serial" style={inp} value={serial} onChange={(e) => setSerial(e.target.value)} /></label>
        </div>
        <button onClick={save} disabled={busy} data-testid="add-machine-save" style={{ ...greenBtn, width: "100%" }}>{busy ? <Loader2 className="mx-auto animate-spin" size={18} /> : "Add machine"}</button>
      </DialogContent>
    </Dialog>
  );
}
